import { useMemo, useState } from "react";
import { reviewList } from "@/mocks/melon";

export default function Reviews() {
  const categories = useMemo(() => ["全部", ...Array.from(new Set(reviewList.map((r) => r.category)))], []);
  const [active, setActive] = useState("全部");

  const list = active === "全部" ? reviewList : reviewList.filter((r) => r.category === active);

  return (
    <section id="review" className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 text-xs font-bold tracking-widest text-primary-500">FEATURED STORIES</p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">大事件复盘</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              把爆红的来龙去脉一次讲透，读完一篇基本能完整弄明白整件事到底怎么回事。
            </p>
          </div>
          <div className="flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-50 p-1">
            {categories.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setActive(c)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
                  active === c ? "bg-primary-500 font-medium text-background-50" : "text-foreground-600 hover:bg-background-100"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((r) => (
            <article key={r.title} className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <div className="relative block aspect-[8/5] w-full overflow-hidden bg-background-100">
                <img
                  src={r.image}
                  alt={`${r.title} 事件复盘封面`}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-700">
                  {r.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-book-open-line" aria-hidden="true" />
                    约 {r.minutes} 分钟
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line" aria-hidden="true" />
                    {r.date}
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950">{r.title}</h3>
                <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{r.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
                  <i className="ri-article-line" aria-hidden="true" />
                  本周精选
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}